import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  AddCustomerAction,
  DeleteCustomerAction,
  GetAllCustomersAction,
  UpdateCustomerAction,
} from './customers.actions';
import { HttpService } from '../../core/services/http/http.service';
import { ICliente } from '../../core/interfaces/customers.interface';
import { EnovaAlertsComponent } from '../../core/utils/enova-alerts/enova-alerts.component';
import { MatDialog } from '@angular/material/dialog';

export interface CustomersStateModel {
  customers: ICliente[];
}

@State<CustomersStateModel>({
  name: 'customers',
  defaults: {
    customers: [],
  },
})
@Injectable()
export class CustomersState {
  @Selector() static GetAllData(state: CustomersStateModel): ICliente[] {
    return state?.customers ?? [];
  }

  constructor(
    private httpService: HttpService,
    private dialog: MatDialog
  ) {}

  @Action(GetAllCustomersAction)
  async GetAllCustomersAction(ctx: StateContext<CustomersStateModel>) {
    try {
      try {
        const resp = await this.httpService.getCustomers();
        if (resp && resp.length) {
          ctx.patchState({
            customers: resp,
          });
        }
      } catch (error) {
        console.error(error);
      }
    } finally {
    }
  }

  @Action(AddCustomerAction)
  async AddCustomerAction(
    ctx: StateContext<CustomersStateModel>,
    { payload }: AddCustomerAction
  ) {
    return this.httpService
      .postCustomer(payload)
      .then(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'success',
            text: 'El cliente se ha creado de forma exitosa!',
            hiddeCancelBtn: true,
          },
        });
        ctx.dispatch(new GetAllCustomersAction());
      })
      .catch(err => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            hiddeCancelBtn: true,
          },
        });
      });
  }

  @Action(UpdateCustomerAction)
  async UpdateCustomerAction(
    ctx: StateContext<CustomersStateModel>,
    { payload }: UpdateCustomerAction
  ) {
    return this.httpService
      .updateCustomer(payload)
      .then(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'success',
            text: '¡El cliente se ha actualizado de forma exitosa!',
            hiddeCancelBtn: true,
          },
        });
        ctx.dispatch(new GetAllCustomersAction());
      })
      .catch(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            hiddeCancelBtn: true,
          },
        });
      });
  }

  @Action(DeleteCustomerAction)
  async DeleteCustomerAction(
    ctx: StateContext<CustomersState>,
    { payload }: DeleteCustomerAction
  ) {
    return this.httpService
      .deleteCustomer(payload)
      .then(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'success',
            text: 'El cliente se ha eliminado de forma exitosa!',
            hiddeCancelBtn: true,
          },
        });
        ctx.dispatch(new GetAllCustomersAction());
      })
      .catch(() => {
        this.dialog.open(EnovaAlertsComponent, {
          width: 'auto',
          data: {
            type: 'error',
            hiddeCancelBtn: true,
          },
        });
      });
  }
}
